export const paths = {
    'homePage': '/',
    'creditsPage': '/credits',
    'undefined': '*'
}